import { render, staticRenderFns } from "./VuePageTransition.vue?vue&type=template&id=6c2e64d2&scoped=true&"
import script from "./VuePageTransition.vue?vue&type=script&lang=js&"
export * from "./VuePageTransition.vue?vue&type=script&lang=js&"
import style0 from "./VuePageTransition.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VuePageTransition.vue?vue&type=style&index=1&id=6c2e64d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2e64d2",
  null
  
)

export default component.exports